<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" width="1600px" :close-on-click-modal="false" :close-on-press-escape="false" @close="handleClose" top="5vh">
    <div class="dialog-content">
      <!-- 头部信息区域 -->
      <div class="header-section" style="width: 1480px !important;">
        <div class="section-title">基本信息</div>
        <el-form ref="headerForm" :model="headerForm" :rules="headerRules" label-width="140px" size="small">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="客户名称" prop="compCode">
                <el-select v-model="headerForm.compCode" placeholder="请选择客户名称" filterable clearable style="width: 100%" @change="handleCustomerChange" @focus="loadCustomerOptions" :disabled="isEdit">
                  <el-option v-for="item in customerOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人" prop="contactPerson">
                <el-input v-model="headerForm.contactPerson" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="headerForm.contactPhone" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="开票主体" prop="invoiceEntity">
                <el-input v-model="headerForm.invoiceEntity" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="跟单员" prop="followUpPerson">
                <el-input v-model="headerForm.followUpPerson" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="项目来源" prop="projectSource">
                <el-input v-model="headerForm.projectSource" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="状态" prop="status">
                <el-input v-model="headerForm.status" placeholder="请选择客户后自动填充" readonly />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 返点方案详细配置 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="返点方案" prop="rebatePlan">
                <el-input :value="getRebateText(Number(headerForm.rebatePlan))" placeholder="自动填充" style="width: 100%" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=1：固定百分比 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 1 || headerForm.rebatePlan === '1'">
            <el-col :span="8">
              <el-form-item label="开始日期">
                <el-date-picker v-model="headerForm.fixedRebateStart" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结束日期">
                <el-date-picker v-model="headerForm.fixedRebateEnd" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="返点百分比">
                <el-input v-model="headerForm.ratioValue" placeholder="请输入百分比(如50)" clearable disabled>
                  <template slot="suffix">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="headerForm.fixedRebateRemark" placeholder="请输入备注" clearable disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=2：按检测日期以及层数不同百分比 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 2 || headerForm.rebatePlan === '2'">
            <el-col :span="24">
              <el-form-item label="返点百分比设置">
                <el-table :data="headerForm.rebateTiers" border size="small" style="width: 100%;">
                  <el-table-column label="开始日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="结束日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.endDate" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="层数" width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.level" placeholder="请输入层数" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="(含当前层)以下折扣为" width="220">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层(含当前层)以下折扣为</span>
                        <el-input v-model="scope.row.belowPercent" placeholder="请输入百分比" disabled>
                          <template slot="suffix">%</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="以上折扣为" width="200">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层以上折扣为</span>
                        <el-input v-model="scope.row.abovePercent" placeholder="请输入百分比" disabled>
                          <template slot="suffix">%</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=3：固定单台费用 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 3 || headerForm.rebatePlan === '3'">
            <el-col :span="8">
              <el-form-item label="开始日期">
                <el-date-picker v-model="headerForm.fixedRebateStart" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结束日期">
                <el-date-picker v-model="headerForm.fixedRebateEnd" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单台返点金额">
                <el-input v-model="headerForm.unitRebateAmount" placeholder="请输入金额" clearable disabled>
                  <template slot="suffix">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="headerForm.fixedRebateRemark" placeholder="请输入备注" clearable disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 返点方案type=4：按层数不同百分比及固定单台返点 -->
          <el-row :gutter="20" v-if="headerForm.rebatePlan == 4 || headerForm.rebatePlan === '4'">
            <el-col :span="24">
              <el-form-item label="返点配置">
                <el-table :data="headerForm.rebateTiers" border size="small" style="width: 100%;">
                  <el-table-column label="开始日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.startDate" type="date" placeholder="选择开始日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="结束日期" width="200">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.endDate" type="date" placeholder="选择结束日期" style="width: 100%;" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="层数" width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.level" placeholder="请输入层数" disabled />
                    </template>
                  </el-table-column>
                  <el-table-column label="(含当前层)以下百分比" width="220">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层(含)以下</span>
                        <el-input v-model="scope.row.belowPercent" placeholder="百分比" disabled>
                          <template slot="suffix">%</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="以上单台金额" width="180">
                    <template slot-scope="scope">
                      <div style="display:flex;align-items:center;gap:8px;">
                        <span>{{ scope.row.level || '—' }}层以上</span>
                        <el-input v-model="scope.row.aboveUnitPrice" placeholder="金额" disabled>
                          <template slot="suffix">元</template>
                        </el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <!-- 详细信息列表区域 -->
      <div class="detail-section">
        <div class="section-title">
          <span>详细信息</span>
          <div class="section-actions">
            <el-upload ref="excelUpload" action="" :auto-upload="false" :show-file-list="false" :on-change="handleExcelImport" accept=".xlsx,.xls" :disabled="isEdit">
              <el-button size="small" type="primary" icon="el-icon-upload2" :disabled="isEdit">详细信息导入</el-button>
            </el-upload>
            <el-button size="small" type="success" icon="el-icon-plus" @click="handleAddRow" :disabled="isEdit">新增</el-button>
          </div>
        </div>

        <el-table :data="detailList" border stripe size="small" max-height="400" style="width: 100%; margin-top: 10px">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="现场联系人" min-width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.siteContact" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="现场联系人电话" min-width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.siteContactTel" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="使用单位" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.usingUnit" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="小区名称" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.houseName" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="识别码" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.OIDNO" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="统一信用代码" min-width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.unifiedCreditCode" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="到检年月" min-width="140">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.inspectionMonth" type="month" placeholder="选择年月" value-format="yyyy-MM" format="yyyy年MM月" size="small" style="width: 100%" />
            </template>
          </el-table-column>
          <el-table-column label="登记日期" min-width="140">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.registrationDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="small" style="width: 100%" />
            </template>
          </el-table-column>
          <el-table-column label="单位使用地址" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.USE_UNT_ADDR" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="折扣" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.finalDisc" placeholder="0-1" size="small" @input="handleDiscInput(scope.row)" :disabled="!!scope.row.finalPrice" />
            </template>
          </el-table-column>
          <el-table-column label="固定价" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.finalPrice" placeholder="请输入" size="small" @input="handlePriceInput(scope.row)" :disabled="!!scope.row.finalDisc" />
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" size="small" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDeleteRow(scope.$index)" :disabled="isEdit" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryCustBaseList, queryCustBaseDetail, queryCustInfo, saveCustInfo, updateCustInfo } from '@/api/contract/contract.js'
import * as XLSX from 'xlsx'

export default {
  name: 'AddAndEdit',

  data () {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      editId: '',

      // 客户选项列表
      customerOptions: [],
      customerLoading: false,

      // 头部表单验证规则
      headerRules: {
        compCode: [
          { required: true, message: '请选择客户名称', trigger: 'change' }
        ]
      },

      // 头部表单数据
      headerForm: {
        compCode: '',
        customerName: '',
        contactPerson: '',
        contactPhone: '',
        followUpPerson: '',
        projectSource: '',
        invoiceEntity: '',
        status: '',
        rebatePlan: '',
        // 返点方案相关字段
        ratioValue: '', // 固定返点百分比
        fixedRebateStart: '', // 固定返点开始日期
        fixedRebateEnd: '', // 固定返点结束日期
        fixedRebateRemark: '', // 固定返点备注
        unitRebateAmount: '', // 单台返点金额
        rebateTiers: [] // 按层数返点配置
      },

      // 详细信息列表
      detailList: []
    }
  },
  computed: {
    dialogTitle () {
      return this.isEdit ? '修改客户检测信息' : '新增客户检测信息'
    }
  },
  methods: {
    // 状态映射
    getStatusText (status) {
      switch (status) {
        case 'ongoing': return '进行中'
        case 'completed': return '完结'
        default: return '未知'
      }
    },
    // 返点方案映射
    getRebateText (rebateType) {
      switch (rebateType) {
        case 1: return '固定百分比'
        case 2: return '按检测日期以及层数不同百分比'
        case 3: return '固定单台费用'
        case 4: return '按层数不同百分比及固定单台返点'
        default: return ''
      }
    },
    /**
     * 加载返点配置
     */
    loadRebateConfig (d, base) {
      // 清空返点配置
      this.headerForm.ratioValue = ''
      this.headerForm.fixedRebateStart = ''
      this.headerForm.fixedRebateEnd = ''
      this.headerForm.fixedRebateRemark = ''
      this.headerForm.unitRebateAmount = ''
      this.headerForm.rebateTiers = []

      // 设置返点方案
      const rebateTypeRaw = (d && d.rebateType != null) ? d.rebateType : (base ? base.rebateType : undefined)
      const rebateType = (rebateTypeRaw !== undefined && rebateTypeRaw !== '') ? Number(rebateTypeRaw) : null
      this.headerForm.rebatePlan = rebateType != null ? rebateType : ''

      // 解析返点配置
      const rebateList = d.rebateList || base.rebateList || []
      if (rebateType === 1 && Array.isArray(rebateList) && rebateList.length > 0) {
        // 固定返点
        const rebate = rebateList[0]
        this.headerForm.ratioValue = rebate.ratioValue || ''
        this.headerForm.fixedRebateStart = this.formatDate(rebate.beginDate) || ''
        this.headerForm.fixedRebateEnd = this.formatDate(rebate.endDate) || ''
        this.headerForm.fixedRebateRemark = rebate.remark || ''
      } else if (rebateType === 2 && Array.isArray(rebateList)) {
        // 按层数返点
        const rebateMap = {}
        rebateList.forEach(item => {
          const floorNum = parseInt(item.floorNum, 10)
          if (isNaN(floorNum)) return
          const beginDate = this.formatDate(item.beginDate) || ''
          const endDate = this.formatDate(item.endDate) || ''
          if (floorNum < 0) {
            const level = Math.abs(floorNum)
            rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', abovePercent: '', remark: item.remark || '' }
            rebateMap[level].belowPercent = item.ratioValue || ''
          } else {
            const level = floorNum - 1
            if (level >= 0) {
              rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', abovePercent: '', remark: item.remark || '' }
              rebateMap[level].abovePercent = item.ratioValue || ''
            }
          }
        })
        this.headerForm.rebateTiers = Object.keys(rebateMap).sort((a, b) => Number(a) - Number(b)).map(k => rebateMap[k])
      } else if (rebateType === 3 && Array.isArray(rebateList) && rebateList.length > 0) {
        // 固定单台费用
        const rebate = rebateList[0]
        this.headerForm.unitRebateAmount = rebate.unitPrice || rebate.unitAmount || rebate.ratioValue || ''
        this.headerForm.fixedRebateStart = this.formatDate(rebate.beginDate) || ''
        this.headerForm.fixedRebateEnd = this.formatDate(rebate.endDate) || ''
        this.headerForm.fixedRebateRemark = rebate.remark || ''
      } else if (rebateType === 4 && Array.isArray(rebateList)) {
        // 按层数不同百分比及固定单台返点
        const rebateMap = {}
        rebateList.forEach(item => {
          const floorNum = parseInt(item.floorNum, 10)
          if (isNaN(floorNum)) return
          const beginDate = this.formatDate(item.beginDate) || ''
          const endDate = this.formatDate(item.endDate) || ''
          if (floorNum < 0) {
            const level = Math.abs(floorNum)
            rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', aboveUnitPrice: '', unitAmount: item.unitAmount || '', remark: item.remark || '' }
            rebateMap[level].belowPercent = item.ratioValue || ''
          } else {
            const level = floorNum - 1
            if (level >= 0) {
              rebateMap[level] = rebateMap[level] || { startDate: beginDate, endDate: endDate, level: String(level), belowPercent: '', aboveUnitPrice: '', unitAmount: item.unitAmount || '', remark: item.remark || '' }
              rebateMap[level].aboveUnitPrice = item.unitPrice || item.unitAmount || ''
            }
          }
        })
        this.headerForm.rebateTiers = Object.keys(rebateMap).sort((a, b) => Number(a) - Number(b)).map(k => rebateMap[k])
      }
    },
    /**
     * 格式化日期
     */
    formatDate (dateStr) {
      if (!dateStr) return ''
      if (typeof dateStr === 'string') {
        // 如果已经是 yyyy-mm-dd 格式，直接返回
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
          return dateStr
        }
        // 尝试解析其他格式
        const date = new Date(dateStr)
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day}`
        }
      }
      return dateStr
    },
    getToday () {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    /**
     * 折扣输入时限制只能输入0-1之间的小数
     */
    handleDiscInput (row) {
      let value = row.finalDisc
      if (value) {
        value = value.replace(/[^\d.]/g, '')
        const parts = value.split('.')
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('')
        }
        if (parts[0] && parseInt(parts[0]) > 1) {
          value = '1'
        }
        if (parts[0] === '1' && parts.length > 1 && parts[1]) {
          value = '1'
        }
        const newParts = value.split('.')
        if (newParts.length === 2 && newParts[1].length > 2) {
          value = newParts[0] + '.' + newParts[1].substring(0, 2)
        }
        row.finalDisc = value
      }
    },
    /**
     * 固定价输入时限制只能输入数字
     */
    handlePriceInput (row) {
      let value = row.finalPrice
      if (value) {
        value = value.replace(/[^\d.]/g, '')
        const parts = value.split('.')
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('')
        }
        if (parts.length === 2 && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2)
        }
        row.finalPrice = value
      }
    },
    /**
     * 加载客户名称选项列表
     * TODO: 后期接入API，调用获取客户列表接口
     */
    loadCustomerOptions () {
      // 如果正在加载中，则不重复加载
      if (this.customerLoading) return
      this.customerLoading = true

      const payload = { currPage: 1, pageSize: 500 }
      queryCustBaseList(payload).then(res => {
        this.customerLoading = false
        // 兼容响应结构，CustomerManagement 使用 res.additionalData.records
        const list = (res && res.additionalData && Array.isArray(res.additionalData.records)) ? res.additionalData.records : []
        const mappedList = list.map(item => {
          const status = (item.enabledState === 0 ? 'completed' : 'ongoing')
          return {
            value: item.compCode || '',
            label: item.compName || '',
            data: {
              compCode: item.compCode || '',
              customerName: item.compName || '',
              contactPerson: item.contactPerson || '',
              contactPhone: item.contactTel || '',
              followUpPerson: item.followPerson || '',
              projectSource: item.projectSource || '',
              invoiceEntity: item.compEntityName || '',
              status: this.getStatusText(status),
              rebatePlan: item.rebateType || '',
              rebateType: item.rebateType,
              rebateList: Array.isArray(item.rebateList) ? item.rebateList : []
            }
          }
        })
        // 根据 compName 去重，保留第一个出现的记录
        const nameMap = new Map()
        this.customerOptions = mappedList.filter(item => {
          const compName = item.label || ''
          if (!nameMap.has(compName)) {
            nameMap.set(compName, true)
            return true
          }
          return false
        })
      }).catch(err => {
        this.customerLoading = false
        console.error(err)
        this.$message.error('获取客户列表失败')

      })
    },

    /**
     * 客户名称改变事件
     */
    handleCustomerChange (value) {
      if (!value) {
        this.headerForm.compCode = ''
        this.headerForm.customerName = ''
        this.headerForm.contactPerson = ''
        this.headerForm.contactPhone = ''
        this.headerForm.followUpPerson = ''
        this.headerForm.projectSource = ''
        this.headerForm.invoiceEntity = ''
        this.headerForm.status = ''
        this.headerForm.rebatePlan = ''
        this.headerForm.ratioValue = ''
        this.headerForm.fixedRebateStart = ''
        this.headerForm.fixedRebateEnd = ''
        this.headerForm.fixedRebateRemark = ''
        this.headerForm.unitRebateAmount = ''
        this.headerForm.rebateTiers = []
        this.detailList = []
        return
      }

      const selectedCustomer = this.customerOptions.find(item => item.value === value)
      if (selectedCustomer && selectedCustomer.data) {
        const data = selectedCustomer.data
        this.headerForm.customerName = data.customerName || ''
        this.headerForm.contactPerson = data.contactPerson || ''
        this.headerForm.contactPhone = data.contactPhone || ''
        this.headerForm.followUpPerson = data.followUpPerson || ''
        this.headerForm.projectSource = data.projectSource || ''
        this.headerForm.invoiceEntity = data.invoiceEntity || ''
        this.headerForm.status = data.status || ''
        // 加载返点配置
        this.loadRebateConfig(data, {})
      }
    },

    /**
     * 新增一行详细信息
     */
    handleAddRow () {
      if (this.isEdit) {
        this.$message.warning('编辑模式不支持新增行')
        return
      }
      let newRow
      if (this.detailList && this.detailList.length > 0) {
        const lastRow = this.detailList[this.detailList.length - 1]
        newRow = {
          ...lastRow,
          finalDisc: lastRow.finalDisc || '',
          finalPrice: lastRow.finalPrice || ''
        }
      } else {
        newRow = {
          siteContact: '',
          siteContactTel: '',
          usingUnit: '',
          houseName: '',
          OIDNO: '',
          unifiedCreditCode: '',
          inspectionMonth: '',
          registrationDate: this.getToday(),
          USE_UNT_ADDR: '',
          finalDisc: '',
          finalPrice: '',
          remark: ''
        }
      }
      this.detailList.push(newRow)
    },

    /**
     * 删除一行详细信息
     */
    handleDeleteRow (index) {
      if (this.isEdit) {
        this.$message.warning('编辑模式不支持删除行')
        return
      }
      this.$confirm('确定要删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailList.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => { })
    },

    /**
     * 处理Excel文件导入
     */
    handleExcelImport (file) {
      if (this.isEdit) {
        this.$message.warning('编辑模式不支持导入')
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

          // 解析Excel数据
          this.parseExcelData(jsonData)
        } catch (error) {
          this.$message.error('Excel文件解析失败，请检查文件格式')
          console.error(error)
        }
      }
      reader.readAsArrayBuffer(file.raw)
    },

    /**
     * 解析Excel数据并填充到详细信息列表
     * Excel格式预期：第一行为表头，从第二行开始为数据
     * 列顺序：
     * 1. 现场联系人
     * 2. 现场联系人电话
     * 3. 使用单位
     * 4. 小区名称
     * 5. 识别码(OIDNO)
     * 6. 统一信用代码(unifiedCreditCode)
     * 7. 到检年月
     * 8. 登记日期
     * 9. 固定价
     * 10. 备注
     */
    parseExcelData (jsonData) {
      if (!jsonData || jsonData.length < 2) {
        this.$message.warning('Excel文件中没有数据')
        return
      }

      const importedData = []
      // 从第二行开始读取数据（跳过表头）
      for (let i = 1; i < jsonData.length; i++) {
        const row = jsonData[i]
        if (!row || row.length === 0) continue

        const detailRow = {
          siteContact: row[0] ? String(row[0]).trim() : '',
          siteContactTel: row[1] ? String(row[1]).trim() : '',
          usingUnit: row[2] ? String(row[2]).trim() : '',
          houseName: row[3] ? String(row[3]).trim() : '',
          OIDNO: row[4] ? String(row[4]).trim() : '',
          unifiedCreditCode: row[5] ? String(row[5]).trim() : '',
          inspectionMonth: row[6] ? this.parseExcelDate(row[6]) : '',
          registrationDate: row[7] ? this.parseExcelFullDate(row[7]) : this.getToday(),
          USE_UNT_ADDR: row[8] ? String(row[8]).trim() : '',
          finalPrice: row[9] ? String(row[9]).trim() : '',
          remark: row[10] ? String(row[10]).trim() : ''
        }
        importedData.push(detailRow)
      }

      if (importedData.length > 0) {
        // 询问是追加还是覆盖
        if (this.detailList.length > 0) {
          this.$confirm(`当前已有 ${this.detailList.length} 条数据，是否要覆盖？选择"取消"将追加数据。`, '提示', {
            confirmButtonText: '覆盖',
            cancelButtonText: '追加',
            type: 'warning'
          }).then(() => {
            this.detailList = importedData
            this.$message.success(`成功导入 ${importedData.length} 条数据（覆盖模式）`)
          }).catch(() => {
            this.detailList.push(...importedData)
            this.$message.success(`成功导入 ${importedData.length} 条数据（追加模式）`)
          })
        } else {
          this.detailList = importedData
          this.$message.success(`成功导入 ${importedData.length} 条数据`)
        }
      } else {
        this.$message.warning('未能解析到有效数据')
      }
    },

    /**
     * 解析Excel中的日期格式
     */
    parseExcelDate (value) {
      if (!value) return ''

      // 如果已经是字符串格式（如 "2024-01"），直接返回
      if (typeof value === 'string') {
        return value
      }

      // 如果是Excel日期数字格式，需要转换
      if (typeof value === 'number') {
        const date = XLSX.SSF.parse_date_code(value)
        if (date) {
          const year = date.y
          const month = String(date.m).padStart(2, '0')
          return `${year}-${month}`
        }
      }

      return String(value)
    },

    /**
     * 解析Excel中的完整日期格式到 yyyy-MM-dd
     */
    parseExcelFullDate (value) {
      if (!value) return ''

      if (typeof value === 'string') {
        // 简单规范化：若为 yyyy/M/d 等，尝试用 Date 解析
        const d = new Date(value)
        if (!isNaN(d.getTime())) {
          const y = d.getFullYear()
          const m = String(d.getMonth() + 1).padStart(2, '0')
          const day = String(d.getDate()).padStart(2, '0')
          return `${y}-${m}-${day}`
        }
        return value
      }

      if (typeof value === 'number') {
        const date = XLSX.SSF.parse_date_code(value)
        if (date) {
          const year = date.y
          const month = String(date.m).padStart(2, '0')
          const day = String(date.d).padStart(2, '0')
          return `${year}-${month}-${day}`
        }
      }

      return String(value)
    },

    /**
     * 显示弹出层 - 新增
     */
    showAdd () {
      this.visible = true
      this.isEdit = false
      this.resetForm()
    },

    /**
     * 显示弹出层 - 修改
     */
    async showEdit (row) {
      this.visible = true
      this.isEdit = true
      this.resetForm()

      // 解析 custPid
      const custPid = (typeof row === 'string' || typeof row === 'number') ? row : (row && (row.custPid || row.id))
      if (!custPid) {
        this.$message.warning('缺少 custPid，无法加载详情')
        return
      }

      this.loading = true
      try {
        // 保存custPid用于更新
        this.editId = custPid

        // 填充客户编码
        const compCode = row.compCode || ''
        this.headerForm.compCode = compCode
        
        // 根据 compCode 获取客户详情（包含开票主体、跟单员等信息）
        if (compCode) {
          const custRes = await queryCustBaseDetail(compCode)
          if (custRes && custRes.retCode === 'ok' && custRes.additionalData) {
            const custData = custRes.additionalData
            this.headerForm.customerName = custData.compName || row.compName || ''
            this.headerForm.contactPerson = custData.contactPerson || ''
            this.headerForm.contactPhone = custData.contactTel || ''
            this.headerForm.followUpPerson = custData.followPerson || ''
            this.headerForm.projectSource = custData.projectSource || ''
            this.headerForm.invoiceEntity = custData.compEntityName || ''
            this.headerForm.status = custData.enabledState === 0 ? '完结' : '进行中'
            
            // 加载返点配置
            this.loadRebateConfig(custData, {})
          }
        }
        
        // 从 contactAndTel 解析联系人和电话（如果客户详情没有返回）
        if (row.contactAndTel && !this.headerForm.contactPerson) {
          const parts = row.contactAndTel.split('/')
          if (parts.length >= 1) this.headerForm.contactPerson = parts[0] || ''
          if (parts.length >= 2) this.headerForm.contactPhone = parts[1] || ''
        }
        
        // 客户名称兜底
        if (!this.headerForm.customerName && row.compName) {
          this.headerForm.customerName = row.compName
        }

        // 填充详细信息（单条数据）
        this.detailList = [{
          custPid: row.custPid || '',
          entrustNum: row.entrustNum || '',
          siteContact: row.siteContact || '',
          siteContactTel: row.siteContactTel || '',
          usingUnit: row.usingUnit || '',
          houseName: row.houseName || '',
          OIDNO: row.OIDNO || '',
          unifiedCreditCode: row.unifiedCreditCode || '',
          inspectionMonth: row.inspectionMonth || '',
          registrationDate: row.registrationDate || this.getToday(),
          USE_UNT_ADDR: row.USE_UNT_ADDR || '',
          finalPrice: (row.finalPrice !== undefined && row.finalPrice !== null) ? String(row.finalPrice) : '',
          remark: row.remark || ''
        }]

        this.loading = false
      } catch (err) {
        this.loading = false
        console.error('获取详情失败:', err)
        this.$message.error('获取详情失败')
      }
    },

    /**
     * 重置表单
     */
    resetForm () {
      this.headerForm = {
        compCode: '',
        customerName: '',
        contactPerson: '',
        contactPhone: '',
        followUpPerson: '',
        projectSource: '',
        invoiceEntity: '',
        status: '',
        rebatePlan: '',
        // 返点方案相关字段
        ratioValue: '',
        fixedRebateStart: '',
        fixedRebateEnd: '',
        fixedRebateRemark: '',
        unitRebateAmount: '',
        rebateTiers: []
      }
      this.detailList = []
      this.editId = ''
      this.customerOptions = []

      this.$nextTick(() => {
        if (this.$refs.headerForm) {
          this.$refs.headerForm.clearValidate()
        }
      })
    },

    /**
     * 关闭弹出层
     */
    handleClose () {
      this.visible = false
      this.resetForm()
    },

    /**
     * 提交表单
     * TODO: 后期接入API，调用保存/更新接口
     */
    handleSubmit () {
      console.log(this.headerForm);

      // 验证头部表单
      this.$refs.headerForm.validate((valid) => {
        if (!valid) {
          this.$message.warning('请检查基本信息填写是否正确')
          return false
        }

        // 校验是否选择了客户
        if (!this.headerForm.compCode) {
          this.$message.warning('请选择客户名称')
          return false
        }

        // 验证详细信息列表
        if (this.detailList.length === 0) {
          this.$message.warning('请至少添加一条详细信息')
          return false
        }

        // 验证详细信息必填项
        const invalidRows = []
        this.detailList.forEach((row, index) => {
          if (!row.OIDNO) {
            invalidRows.push(index + 1)
          }
        })
        if (invalidRows.length > 0) {
          this.$message.warning(`第 ${invalidRows.join(', ')} 行的识别码不能为空`)
          return false
        }

        this.loading = true

        let apiCall
        if (this.isEdit) {
          // 编辑模式：提交数组（后端接受List），包含单条数据
          const first = this.detailList[0] || {}
          const submitObj = {
            ...first,
            compCode: this.headerForm.compCode,
            custPid: this.editId
          }
          apiCall = updateCustInfo([submitObj])
        } else {
          // 新增模式：提交数组，且每条附带 compCode
          const submitArray = this.detailList.map(item => ({
            ...item,
            compCode: this.headerForm.compCode
          }))
          apiCall = saveCustInfo(submitArray)
        }
        apiCall.then(res => {
          this.loading = false
          if (res && res.retCode === 'ok') {
            this.$message.success(this.isEdit ? '修改成功' : '新增成功')
            this.handleClose()
            this.$emit('refresh')
          } else {
            this.$message.error(res.retMsg || (this.isEdit ? '修改失败' : '新增失败'))
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(err.message || (this.isEdit ? '修改失败' : '新增失败'))
        })

        // 模拟API调用（开发阶段使用）
        // setTimeout(() => {
        //   this.loading = false
        //   console.log('提交的数据：', submitData)
        //   this.$message.success(this.isEdit ? '修改成功' : '保存成功')
        //   this.handleClose()
        //   this.$emit('refresh')
        // }, 1000)
      })
    }
  }
}
</script>

<style scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}

.header-section,
.detail-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 10px 0;
  border-bottom: 2px solid #409eff;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-actions {
  display: flex;
  gap: 10px;
}

.el-form-item {
  margin-bottom: 18px;
}

.dialog-footer {
  text-align: right;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 只读字段样式 */
.el-input.is-disabled >>> .el-input__inner,
.el-input[readonly] >>> .el-input__inner {
  background-color: #f5f7fa;
  color: #606266;
  cursor: not-allowed;
}

/* 表格内输入框样式优化 */
.el-table >>> .el-input__inner,
.el-table >>> .el-input-number__inner {
  border: 1px solid #dcdfe6;
}

.el-table >>> .el-input__inner:focus,
.el-table >>> .el-input-number__inner:focus {
  border-color: #409eff;
}
</style>